.bar {
  background-color: var(--dds-color-surface-default);
  border-bottom: 1px solid var(--dds-color-border-default);
  min-height: 58px;
  .bar-separator {
    margin-left: auto;
  }
}

.bar--with-nav {
  .bar-separator {
    margin-left: 0;
  }

  .context-menu-group {
    margin-left: auto;
  }
}

.bar-separator {
  align-self: stretch;
  border-left: 1px solid var(--dds-color-border-default);
}

.nav-list {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--dds-spacing-x1-5);
}

.nav-list__item {
  display: flex;
}

.nav-list__item__link {
  text-decoration: none;
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1);
  border-radius: var(--dds-border-radius-surface);
  background-color: transparent;
  color: var(--dds-color-text-subtle);

  &:hover {
    background-color: var(--dds-color-surface-hover-subtle);
    color: var(--dds-color-text-default);
  }

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

.nav-list__item__link--active {
  background-color: var(--dds-color-surface-selected-default);
  color: var(--dds-color-text-default);

  &:hover {
    background-color: var(--dds-color-surface-selected-default);
    color: var(--dds-color-text-default);
  }
}

.context-menu {
  max-height: calc(100vh - 110px);
}
